import {Component, OnInit} from '@angular/core';
import {CommonService} from '../_services';
import {Router} from '@angular/router';
import {ActivatedRoute} from '@angular/router';
import {environment} from '../../environments/environment';
import {Chart} from 'angular-highcharts';
import * as Highcharts from 'highcharts/highstock';
import * as moment from 'moment';

@Component({
  selector: 'app-all-station-device-wise-industry-profile',
  templateUrl: './all-station-device-wise-industry-profile.component.html',
  styleUrls: ['./all-station-device-wise-industry-profile.component.css']
})
export class AllStationDeviceWiseIndustryProfileComponent implements OnInit {

  public apiBaseUrl: string = environment.apiBaseUrl;
  lineChart: Chart;
  graphPlot = true;
  popupChart: Chart;
  options: any;
  deviceResponseChart = [];
  route: string;
  deviceDataGraphResponse = [];
  data: any;
  popupPeriodSelected = 'today';
  popupTypeSelected = '';
  totalExceedance = 0;
  industryId;
  industryProfileDetail = [];
  stationDeviceLatestResult = [];
  deviceResponse = [];
  stationDeviceDetail = [];

  stationIDPopup = '';
  deviceDetailsPopup = [];
  industryDetailPopup = [];
  stationNamePopup = '';

  viewDataDetailsStationName = '';
  viewDataDetailsIndustryName = '';
  viewDataDetailsIndustryCode = '';
  viewDataDetailsAddress = '';

  getStationDeviceDetailsLoader = false;
  viewDataDetailsLoader = false;
  getStationDeviceGraphLoader = false;
  getStationDeviceLatestResultLoader = false;
  getIndustryDetailLoader = false;
  display = 'none';
  showPopUpReportIcons = false;
  reportStationId = null;
  reportDeviceId = null;
  reportParameter = null;
  reportPeriod = null;
  startReportDate = new Date();
  endReportDate = new Date();
  currentReportDate = new Date();
  oneDayBeforeDate = new Date();
  minStartDate: Date;
  maxStartDate: Date;
  minEndDate: Date;
  maxEndDate: Date;
  userLevel = '';
  vendor_id = '';
  archive = '';

  exccedanceCardLoader = false;
  exceedanceCardDetail = [];

  userData: any = [];

  constructor(private activeroute: ActivatedRoute, private router: Router,
              private _service: CommonService) {
    this.minStartDate = new Date();
    this.maxStartDate = new Date();
    this.minEndDate = new Date();
    this.maxEndDate = new Date();
    this.maxStartDate.setDate(this.maxStartDate.getDate());
  }

  ngOnInit() {

    var dt = new Date();

    if (dt.getHours() <= 4) {
      // @ts-ignore
      this.startTime = dt.getHours() && dt.getHours().toString().length == 1 ? '0' + dt.getHours() : dt.getHours() + ':' + (dt.getMinutes() && dt.getMinutes().toString().length == 1 ? '0' + dt.getMinutes() : dt.getMinutes());
    } else {
      const hours = ((dt.getHours() - 4) && (dt.getHours() - 4).toString().length == 1 ? '0' + (dt.getHours() - 4) : (dt.getHours() - 4));
      const minutes = (dt.getMinutes() && dt.getMinutes().toString().length == 1 ? '0' + dt.getMinutes() : dt.getMinutes());
      // @ts-ignore
      this.startTime = hours + ':' + minutes;
    }
    console.log('this.startTime', this.startTime);
    // @ts-ignore
    this.endTime = this.convertTimeFormat(new Date());

    console.log('this.endTime', this.convertTimeFormat(this.endReportTime));
    this.activeroute.queryParams.subscribe(params => {
      this.industryId = atob(params['industry_id']);
      if (params['archive']) {
        this.archive = params['archive'];
      }
    });

    this.userData = JSON.parse(localStorage.getItem('userData'));

    if (this.userData) {
      this.userLevel = this.userData['access_level'];
      if (this.userLevel == 'vendor') {
        this.vendor_id = this.userData['id'];
      }
    }

    this.getDeviceResponse();
    this.getStationDeviceDetails();
    // this.getStationDeviceLatestResult();
    // this.getDeviceResults();
    this.getIndustryDetail();

    // this.drawLineChart();

    setInterval(() => {
      this.getDeviceResponse();
      this.getStationDeviceDetails();
      // this.getStationDeviceLatestResult();
      // this.getDeviceResults();
      this.getIndustryDetail();
      // this.drawLineChart();
    }, 5000 * 60 * 3);

  }


  // onStartDateChange(value: Date): void {
  //   this.startReportDate = value;
  //   this.oneDayBeforeDate.setDate(this.currentReportDate.getDate() - 1);
  //   var startDateString = "'"+this.startReportDate+"'";
  //   var currentDateString = "'"+this.currentReportDate+"'";
  //   var oneDayBeforeDate = "'"+this.oneDayBeforeDate+"'";
  //
  //   this.maxEndDate = new Date();
  //   this.minEndDate.setDate(this.startReportDate.getDate());
  //
  //   if(!(oneDayBeforeDate.localeCompare(startDateString))) {
  //
  //     this.maxEndDate.setDate(this.currentReportDate.getDate());
  //   } else if(!(startDateString.localeCompare(currentDateString))) {
  //
  //     this.maxEndDate.setDate(this.startReportDate.getDate());
  //   } else {
  //
  //     this.maxEndDate.setDate(this.startReportDate.getDate() + 2);
  //   }
  //   // this.endReportDate = this.startReportDate;
  // }
  //
  // onEndDateChange(value: Date): void {
  //   this.endReportDate = value;
  // }

  onStartDateChange(value: Date): void {
    this.startReportDate = value;
    this.maxEndDate = new Date();
    this.minEndDate.setDate(this.startReportDate.getDate());
    this.minEndDate = new Date(value);
  }

  startReportTime: '';
  endReportTime: '';
  startTime: '';
  endTime: '';

  onEndDateChange(value: Date): void {
    this.endReportDate = value;
    this.maxStartDate = new Date(value);
  }

  viewDiagnostics(stationID, deviceDetails, industryDetail, stationName, period) {

    this.popupPeriodSelected = period;

    this.stationIDPopup = stationID;
    this.deviceDetailsPopup = deviceDetails;
    this.industryDetailPopup = industryDetail;
    this.stationNamePopup = stationName;

    this.popupTypeSelected = 'diagnostic';
    this.viewDataDetailsLoader = true;
    this.display = 'block';

    this.viewDataDetailsStationName = stationName;
    this.viewDataDetailsIndustryName = industryDetail.name;
    this.viewDataDetailsIndustryCode = industryDetail.code;
    this.viewDataDetailsAddress = industryDetail.address;

    this.route = 'get-station-device-diagnostic-value';
    const token = localStorage.getItem('userToken');

    this.showPopUpReportIcons = false;

    let data = {
      'station_id': stationID,
      'device_id': deviceDetails.device_id,
      'parameter': deviceDetails.paramkey,
      'period': this.popupPeriodSelected
    };
    this._service.postRequestCreator(data, this.route, token).subscribe((response: any) => {
      if (response.status == 204) {
        // localStorage.removeItem('userToken');
        // localStorage.removeItem('userData');
        // this.router.navigate(['login']);
        // location.reload();
      }

      if (response.status == 200) {
        this.viewDataDetailsLoader = false;
        let deviceResponseRow = [];
        let parameterName = '';
        let parameterUnit = '';
        let dataSet = [];
        let index = 0;
        this.deviceDataGraphResponse = [];
        let graphValue;

        for (var parameterKey in response.data) {
          parameterName = parameterKey;
          for (var responseKey in response.data[parameterKey]) {

            if (response.data && response.data[parameterKey] && response.data[parameterKey][responseKey] && response.data[parameterKey][responseKey]['flag'] == 'U') {
              // graphValue = 1;
              graphValue = response.data[parameterKey][responseKey]['max'] ? response.data[parameterKey][responseKey]['max'] : 1;
            } else if (response.data && response.data[parameterKey] && response.data[parameterKey][responseKey] && response.data[parameterKey][responseKey]['flag'] == 'C') {
              graphValue = 4;
            } else if (response.data && response.data[parameterKey] && response.data[parameterKey][responseKey] && response.data[parameterKey][responseKey]['flag'] == 'F') {
              graphValue = 5;
            } else if (response.data && response.data[parameterKey] && response.data[parameterKey][responseKey] && response.data[parameterKey][responseKey]['flag'] == 'Z') {
              graphValue = 6;
            } else {
              graphValue = 0;
            }
            parameterUnit = response.data[parameterKey][responseKey]['unit'];
            dataSet.push([Date.parse(response.data[parameterKey][responseKey]['date_time']), parseFloat(graphValue)]);
          }
          this.deviceDataGraphResponse[index] = {
            'name': (parameterKey && parameterKey.toLowerCase() == 'ph' ? 'pH' : parameterKey),
            'data': dataSet
          };
          index = index + 1;
        }

        var keys = Object.keys(response.data);

        if (keys.length) {
          this.graphPlot = true;
          this.drawPopupGraph(this.deviceDataGraphResponse, deviceDetails, 'diagnostic', parameterUnit);
        } else {
          this.graphPlot = false;
        }
        // this.drawDiagnostics(this.deviceDataGraphResponse,deviceDetails,'diagnostic');

      }
    });
  }

  printPage() {
    window.print();
  }


  // exportReportGet(file_type){
  //
  //    this.route  = 'industry-profile-details-export/'+this.industryId+'/'+file_type;
  //   //this.route  = 'industry-profile-details-export';
  //   const token    = localStorage.getItem('userToken');
  //
  //   let data = {'industry_id':this.industryId, 'file_type':file_type};
  //
  //   this._service.getRequestCreator(this.route, token).subscribe((response: any) => {
  //     if(response.status == 204) {
  //       localStorage.removeItem('userToken');
  //       localStorage.removeItem('userData');
  //       this.router.navigate(['login']);
  //     }
  //     if(response.status == 200){
  //
  //     }
  //   });
  // }

  convertDateFormat(dateObj) {

    var result_date = new Date(dateObj);
    var str = result_date.getFullYear() + '-' +
      ((result_date.getMonth() + 1) > 9 ? (result_date.getMonth() + 1) : ('0' + (result_date.getMonth() + 1)))
      + '-' +
      (result_date.getDate() > 9 ? result_date.getDate() : ('0' + result_date.getDate()));

    return str;
  }

  convertTimeFormat(dateObj) {

    var result_date = new Date();
    var str = (result_date.getHours() && result_date.getHours().toString().length == 1 ? '0' + result_date.getHours() : result_date.getHours()) + ':' +
      (result_date.getMinutes() && result_date.getMinutes().toString().length == 1 ? '0' + result_date.getMinutes() : result_date.getHours());

    return str;
  }

  exportReport(fileType) {


    if (!this.startReportDate) {
      this.startReportDate = new Date();
    }

    if (!this.endReportDate) {
      this.endReportDate = new Date();
    }

    var start_date = this.convertDateFormat(this.startReportDate);
    var end_date = this.convertDateFormat(this.endReportDate);

    var a;
    const token = localStorage.getItem('userToken');
    a = document.getElementById('export' + fileType + 'href');
    console.log(a);
    if (this.showPopUpReportIcons) {
      if (this.reportPeriod == '') {
        this.reportPeriod = 'all';
      }
      if (this.archive) {
        a.href = this.apiBaseUrl + '/archive-station-wise-industry-profile-details-export/' + this.industryId + '/' + fileType + '/' +
          this.reportStationId + '/' + this.reportDeviceId + '/' + this.reportParameter + '/' + this.reportPeriod + '/' + token;
      } else {
        a.href = this.apiBaseUrl + '/station-wise-industry-profile-details-export/' + this.industryId + '/' + fileType + '/'
          + this.reportStationId + '/' + this.reportDeviceId + '/' + this.reportParameter + '/' + this.reportPeriod + '/' + token;
      }
    } else {
      if (this.archive) {
        a.href = this.apiBaseUrl + '/archive-industry-profile-details-export/' + this.industryId + '/' + fileType +
          '/' + start_date + '/' + end_date + '/' + token;
      } else {
        start_date = this.convertDateFormat(this.startReportDate) + ' ' + (this.startTime + ':00');
        end_date = this.convertDateFormat(this.endReportDate) + ' ' + (this.endTime + ':00');
        // console.log(this.apiBaseUrl+"/industry-profile-details-export/"+this.industryId+"/
        // "+fileType+"/"+start_date+"/"+end_date+"/"+token);
        if (fileType == 'pdf') {
          a.href = this.apiBaseUrl + '/industry-profile-details-export/' + this.industryId + '/' + fileType + '/' + start_date + '/'
            + end_date + '/' + token;
        } else {
          a.href = this.apiBaseUrl + '/industry-profile-details-export/' + this.industryId + '/' + fileType + '/' + start_date + '/'
            + end_date + '/' + token;

          // a.href = this.apiBaseUrl +"/general-industry-daily-export/"+fileType +"/"+token
          //   +"?industry_id="+(this.industryId ? btoa(this.industryId) : btoa(null))
          //   +"&start_date="+(start_date ? btoa(start_date) : btoa(null))
          //   +"&end_date="+(end_date ? btoa(end_date) : btoa(null))
          //   ;
        }
        // console.log( a.href);
      }
    }
    document.getElementById('export' + fileType + 'href').click();
  }

  // exportReportPost(file_type){
  //
  //   this.route  = 'industry-profile-details-export';
  //   const token = localStorage.getItem('userToken');
  //   let data = {'industry_id':this.industryId, 'file_type':file_type};
  //
  //   this._service.postRequestCreator(data, this.route, token).subscribe((response: any) => {
  //
  //     if(response.status == 204) {
  //       localStorage.removeItem('userToken');
  //       localStorage.removeItem('userData');
  //       this.router.navigate(['login']);
  //     }
  //
  //     if(response.status == 200){
  //       alert('ok');
  //       // this.allCityList = response.data;
  //     }
  //   });
  //
  // }

  changePeriodForPopupGraph() {

    if (this.popupTypeSelected == 'data') {
      this.viewData(this.stationIDPopup, this.deviceDetailsPopup, this.industryDetailPopup, this.stationNamePopup, this.popupPeriodSelected);
    }

    if (this.popupTypeSelected == 'diagnostic') {
      this.viewDiagnostics(this.stationIDPopup, this.deviceDetailsPopup, this.industryDetailPopup, this.stationNamePopup, this.popupPeriodSelected);
    }
  }

  viewData(stationID, deviceDetails, industryDetail, stationName, period) {

    this.popupPeriodSelected = period;

    this.stationIDPopup = stationID;
    this.deviceDetailsPopup = deviceDetails;
    this.industryDetailPopup = industryDetail;
    this.stationNamePopup = stationName;

    this.popupTypeSelected = 'data';
    this.viewDataDetailsLoader = true;
    this.display = 'block';

    this.viewDataDetailsStationName = stationName;
    this.viewDataDetailsIndustryName = industryDetail.name;
    this.viewDataDetailsIndustryCode = industryDetail.code;
    this.viewDataDetailsAddress = industryDetail.address;

    this.route = 'get-station-device-diagnostic-value';

    this.showPopUpReportIcons = true;
    this.reportStationId = stationID;
    this.reportDeviceId = deviceDetails.device_id;
    this.reportParameter = deviceDetails.paramkey;
    this.reportPeriod = this.popupPeriodSelected;


    const token = localStorage.getItem('userToken');

    let data = {
      'station_id': stationID,
      'device_id': deviceDetails.device_id,
      'parameter': deviceDetails.paramkey,
      'period': this.popupPeriodSelected
    };
    this._service.postRequestCreator(data, this.route, token).subscribe((response: any) => {

      if (response.status == 204) {
        // localStorage.removeItem('userToken');
        // localStorage.removeItem('userData');
        // this.router.navigate(['login']);
        // location.reload();
      }

      if (response.status == 200) {
        this.viewDataDetailsLoader = false;
        let deviceResponseRow = [];
        let parameterName = '';
        let parameterUnit = '';
        let dataSet = [];
        let index = 0;
        this.deviceDataGraphResponse = [];

        for (var parameterKey in response.data) {
          parameterName = parameterKey;
          parameterUnit = '';
          for (var responseKey in response.data[parameterKey]) {
            dataSet.push([Date.parse(response.data[parameterKey][responseKey]['date_time']), parseFloat(response.data[parameterKey][responseKey]['value'])]);
            parameterUnit = response.data[parameterKey][responseKey]['unit'];
          }

          // dataSet = [[1511481600000,0.8421],[1511740800000,0.8368],[1511827200000,0.8413],[1511913600000,0.8456],[1512000000000,0.8441],[1512086400000,0.8415],[1512345600000,0.8429],[1512432000000,0.8442],[1512518400000,0.8463],[1512604800000,0.8486],[1512691200000,0.8517],[1512950400000,0.8478],[1513036800000,0.85],[1513123200000,0.8522],[1513209600000,0.8443],[1513296000000,0.8471],[1513555200000,0.8479],[1513641600000,0.8459],[1513728000000,0.8443],[1513814400000,0.8433],[1513900800000,0.8438],[1514332800000,0.8408],[1514419200000,0.838],[1514505600000,0.8339]];
          this.deviceDataGraphResponse[index] = {
            'name': (parameterKey && parameterKey.toLowerCase() == 'ph' ? 'pH' : parameterKey),
            'data': dataSet,
            'tooltip': {valueDecimals: 2},
            'parameterUnit': parameterUnit
          };
          index = index + 1;
        }
// alert('here');
        // this.drawDiagnostics(this.deviceDataGraphResponse,deviceDetails,'data');


        var keys = Object.keys(response.data);

        if (keys.length) {
          this.graphPlot = true;
          this.drawPopupGraph(this.deviceDataGraphResponse, deviceDetails, 'data', parameterUnit);
        } else {
          this.graphPlot = false;
        }

      }
    });
  }

  onCloseHandled() {
    this.display = 'none';
    this.showPopUpReportIcons = false;
  }

  getIndustryDetail() {
    this.getIndustryDetailLoader = true;
    this.route = 'get-industry-profile-details';
    const token = localStorage.getItem('userToken');
    this.industryProfileDetail = [];
    let data = {'industry_id': this.industryId, 'is_archive': this.archive};

    this._service.postRequestCreator(data, this.route, token).subscribe((response: any) => {
      if (response.status == 204) {
        // localStorage.removeItem('userToken');
        // localStorage.removeItem('userData');
        // this.router.navigate(['login']);
        // location.reload();
      }
      if (response.status == 200) {
        this.getIndustryDetailLoader = false;
        this.industryProfileDetail = response.data;

        if (this.userLevel == 'vendor' && this.vendor_id) {
          if (this.industryProfileDetail.length && (this.industryProfileDetail[0]['our_vendor_id'] != this.vendor_id)) {
            this.router.navigate(['dashboard']);
          }
        }
      }
    });
  }

  getStationDeviceDetails() {
    this.getStationDeviceDetailsLoader = true;

    this.route = 'get-industry-station-device-details';
    this.stationDeviceDetail = [];
    let data = {'industry_id': this.industryId, 'is_archive': this.archive};
    const token = localStorage.getItem('userToken');

    this._service.postRequestCreator(data, this.route, token).subscribe((response: any) => {
      if (response.status == 204) {
        // localStorage.removeItem('userToken');
        // localStorage.removeItem('userData');
        // this.router.navigate(['login']);
        // location.reload();
      }
      if (response.status == 200) {
        this.stationDeviceDetail = response.data;
        this.getStationDeviceDetailsLoader = false;

        for (var stationId in response.stations) {
          this.getStationDeviceLatestResult(response.stations[stationId]);
        }

        console.log(this.stationDeviceLatestResult);
      }
    });

  }

  getStationDeviceLatestResult(stationId) {

    this.getStationDeviceLatestResultLoader = true;
    this.route = 'get-station-device-latest-result';
    const token = localStorage.getItem('userToken');
    this.stationDeviceLatestResult = [];

    // const start_date = this.convertDateFormat(this.startReportDate);
    // const end_date = this.convertDateFormat(this.endReportDate);

    const start_date = this.convertDateFormat(this.startReportDate) + ' ' + (this.startTime + ':00');
    const end_date = this.convertDateFormat(this.endReportDate) + ' ' + (this.endTime + ':00');

    let data = {
      'industry_id': this.industryId,
      'station_id': stationId,
      'is_archive': this.archive,
      'startDateTime': start_date,
      'endDateTime': end_date
    };

    this._service.postRequestCreator(data, this.route, token).subscribe((response: any) => {
      if (response.status == 204) {
        // localStorage.removeItem('userToken');
        // localStorage.removeItem('userData');
        // this.router.navigate(['login']);
        // location.reload();
      }

      if (response.status == 200) {
        this.getStationDeviceLatestResultLoader = false;
        this.stationDeviceLatestResult['stat_' + stationId] = response.data;
      }
    });


  }

  printChart() {
    const printContent = document.getElementById('parameter-graph-popup-print');
    const WindowPrt = window.open('', '', 'left=0,top=0,width=900,height=900,toolbar=0,scrollbars=0,status=0');
    WindowPrt.document.write(printContent.innerHTML);
    WindowPrt.document.close();
    WindowPrt.focus();
    WindowPrt.print();
    WindowPrt.close();
  }

  drawLineChart(station, parameterKey, parameterName, chartvalue, parameterUnit = null) {

    let lineChartLocal = new Chart({

      title: {
        text: ''
      },
      subtitle: {
        text: ''
      },
      yAxis: {
        title: {
          // visible: false,
          text: (parameterName && parameterName.toLowerCase() == 'ph' ? 'pH' : parameterName) + ' (' + (parameterUnit && parameterUnit.toLowerCase() == 'ph' ? 'pH' : parameterUnit) + ')'
        }
      },
      xAxis: {
        visible: true,
        labels: {
          rotation: -45,
          formatter: function () {
            return moment(new Date(this.value)).format('MMM DD, HH:mm');
          },
        },
      },
      legend: {enabled: false},
      tooltip: {
        backgroundColor: '#EEF3F6',
        borderColor: 'black',
        borderRadius: 10,
        borderWidth: 1,
        formatter: function () {
          return '<b>' + (parameterName && parameterName.toLowerCase() == 'ph' ? 'pH' : parameterName) + ' (' + parameterUnit + ')' + ':</b> ' + this.y + '<br/><b>Time:</b> ' + moment(new Date(this.x)).format('DD MMM YYYY HH:mm');
        }
      },
      credits: {
        enabled: false
      },
      series: [{
        name: 'Installation',
        data: chartvalue,
        type: 'line'
      }],
      responsive: {
        rules: [{
          condition: {
            maxWidth: 500
          },
          chartOptions: {
            legend: {
              layout: 'horizontal',
              align: 'center',
              verticalAlign: 'bottom'
            }
          }
        }]
      }
    });
    this.deviceResponseChart[station][parameterKey] = lineChartLocal;
  }

  drawPopupGraph(deviceDataGraphResponse, deviceDetail, type, parameterUnit = null) {

    let lineChartLocal = new Chart({

      title: {
        text: ''
      },
      subtitle: {
        text: ''
      },
      yAxis: {
        title: {
          // visible: false,
          text: (deviceDetail.label && deviceDetail.label.toLowerCase() == 'ph' ? 'pH' : deviceDetail.label.toUpperCase()) + ' (' + (parameterUnit && parameterUnit.toLowerCase() == 'ph' ? 'pH' : parameterUnit) + ')'
        },
        plotLines: [{
          value: type == 'data' ? deviceDetail.min : null,
          color: 'green',
          dashStyle: 'ShortDash',
          width: 2,
          zIndex: 5,
          label: {
            text: 'Prescribed Standard ' + deviceDetail.min + ' ' + deviceDetail.stdunit
          }
        }, {
          value: type == 'data' ? deviceDetail.max : 1,
          color: 'red',
          dashStyle: 'ShortDash',
          width: 2,
          zIndex: 5,
          label: {
            text: type == 'data' ? 'Prescribed Standard ' + deviceDetail.max + ' ' + deviceDetail.stdunit : 'Max limit 1'
          }
        }]
      },
      xAxis: {
        visible: true,
        labels: {
          rotation: -45,
          formatter: function () {
            return moment(new Date(this.value)).format('MMM DD, HH:mm');
          },
        },
      },
      legend: {enabled: true},
      tooltip: {
        backgroundColor: '#EEF3F6',
        borderColor: 'black',
        borderRadius: 10,
        borderWidth: 1,
        formatter: function () {
          return '<b>' + (deviceDetail.label && deviceDetail.label.toLowerCase() == 'ph' ? 'pH' : deviceDetail.label) + ' (' + parameterUnit + ')' + ':</b> ' + this.y + '<br/><b>Time:</b> ' + moment(new Date(this.x)).format('DD MMM YYYY HH:mm');
        }
      },
      credits: {
        enabled: false
      },
      series: deviceDataGraphResponse,

      responsive: {
        rules: [{
          condition: {
            maxWidth: 500
          },
          chartOptions: {
            legend: {
              layout: 'horizontal',
              align: 'center',
              verticalAlign: 'bottom'
            }
          }
        }]
      }
    });
    this.popupChart = lineChartLocal;
  }

  getDeviceResponse() {

    this.getStationDeviceGraphLoader = true;

    // this.route  = 'get-industry-device-response';
    this.route = 'get-industry-device-response-new';
    const token = localStorage.getItem('userToken');
    this.deviceResponse = [];
    const start_date = this.convertDateFormat(this.startReportDate) + ' ' + (this.startTime + ':00');
    const end_date = this.convertDateFormat(this.endReportDate) + ' ' + (this.endTime + ':00');
    let data = {
      'industry_id': this.industryId,
      'interval': '4 hours',
      'is_archive': this.archive,
      'startDate': start_date,
      'endDate': end_date
    };

    this._service.postRequestCreator(data, this.route, token).subscribe((response: any) => {

      if (response.status == 204) {
        // localStorage.removeItem('userToken');
        // localStorage.removeItem('userData');
        // this.router.navigate(['login']);
        // location.reload();
      }
      if (response.status == 200) {

        this.deviceResponse = response.data;

        for (var stationKey in this.deviceResponse) {

          this.deviceResponseChart[stationKey] = [];

          for (var parameterKey in this.deviceResponse[stationKey]) {

            this.deviceResponseChart[stationKey][parameterKey] = this.lineChart;
            let deviceResponseRow = [];
            let parameterName = '';
            let parameterUnit = '';

            for (var responseKey in this.deviceResponse[stationKey][parameterKey]) {
              deviceResponseRow.push([Date.parse(this.deviceResponse[stationKey][parameterKey][responseKey]['date_time']), parseFloat(this.deviceResponse[stationKey][parameterKey][responseKey]['value'])]);
              parameterName = this.deviceResponse[stationKey][parameterKey][responseKey]['parameter'];
              parameterUnit = this.deviceResponse[stationKey][parameterKey][responseKey]['unit'];
            }

            this.drawLineChart(stationKey, parameterKey, parameterName, deviceResponseRow, parameterUnit);
          }
        }

        this.getStationDeviceGraphLoader = false;

      }

    });
  }

  drawDiagnostics(deviceDataGraphResponse, deviceDetail, type) {

    // Create the chart
    Highcharts.stockChart('devicePopupId', {

      rangeSelector: {
        allButtonsEnabled: true,
        buttons: [{
          type: 'week',
          count: 1,
          text: '1w',
          events: {
            click: function () {
              // alert('licked button');
            }
          }
        }, {
          type: 'month',
          count: 1,
          text: '1m'
        }, {
          type: 'month',
          count: 3,
          text: '3m'
        }, {
          type: 'month',
          count: 6,
          text: '6m'
        }, {
          type: 'ytd',
          text: 'YTD'
        }, {
          type: 'year',
          count: 1,
          text: '1y'
        }, {
          type: 'all',
          text: 'All'
        }],
        buttonTheme: {
          width: 60
        },
        selected: 1
      },
      title: {
        text: ''
      },
      credits: {
        enabled: false
      },

      yAxis: {
        title: {
          text: ''
        },
        plotLines: [{
          value: type == 'data' ? deviceDetail.min : null,
          color: 'green',
          dashStyle: 'ShortDash',
          width: 2,
          label: {
            text: 'Prescribed Standard ' + deviceDetail.min + ' ' + deviceDetail.stdunit
          }
        }, {
          value: type == 'data' ? deviceDetail.max : 1,
          color: 'red',
          dashStyle: 'ShortDash',
          width: 2,
          label: {
            text: type == 'data' ? 'Prescribed Standard ' + deviceDetail.max + ' ' + deviceDetail.stdunit : 'Max limit 1'
          }
        }]
      },
      series: deviceDataGraphResponse
    });
  }

  updateEndTime(event) {
    this.startReportTime = this.startTime;
  }

  updateStartTime(event) {
    this.endReportTime = this.endTime;
  }
}
